import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { usePublisherStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function PublisherGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid />
}

export default function PublisherGridLayout() {
  return <GridProvider store={usePublisherStore()}>
    <PublisherGrid />
  </GridProvider>
}
